export default __webpack_public_path__ + "static/media/Andar-bahar.a799f4f1.jpg";